// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Bmxz","footer":"ModalCreateQualiphyProcedure_footer__2xmlX","additionData":"ModalCreateQualiphyProcedure_additionData__XcRCU"};